import "./skills.css"
import React from "react"
import { FaHtml5 ,FaCss3Alt ,FaReact, FaNodeJs, FaPython, FaJsSquare, FaGitAlt} from 'react-icons/fa';
import { FiFigma } from 'react-icons/fi';
import { SiFirebase } from 'react-icons/si';
import { Doughnut } from 'react-chartjs-2';

const skills = [
  { name: "HTML", value: 98, icon: <FaHtml5 /> },
  { name: "CSS", value: 93, icon: <FaCss3Alt /> },
  { name: "React", value: 80, icon: <FaReact /> },
  { name: "JavaScript", value: 85, icon: <FaJsSquare /> },
  { name: "Node Js", value: 55, icon: <FaNodeJs /> },
  { name: "Python", value: 70, icon: <FaPython /> },
  { name: "Git", value: 85, icon: <FaGitAlt /> },
  { name: "Firebase", value: 85, icon: <SiFirebase /> },
  { name: "C", value: 80, icon: <img src="/C_Logo.png" alt="C-Logo" /> },
  { name: "Figma", value: 80, icon: <FiFigma /> },
];


class Skills extends React.Component {
    constructor(){
        super()
        this.state = {
             
        }
    }
    render(){
        return(
            <div>
                <div id="skill" className="nav-space skill-nav-space"></div>
                <div id="skills">
                    <h1 className="section-head skill-mobile">Skills</h1>
                    <div className="skill-display">
                        <h1 className="skill-desktop">Skills</h1>
                        <div className="chart-div">
                            {skills.map((skill, i)=>{
                                return(<div className="chart-container">
                                        <span className="chart">
                                            <Doughnut 
                                                data={{
                                                    datasets: [
                                                        {
                                                            
                                                        data: [skill.value,100-skill.value],
                                                        backgroundColor: [
                                                            '#FC814A',
                                                            '#7d6b9193',
                                                        ],
                                                        borderWidth: 0
                                                    }
                                                    ]
                                                }} 

                                                options={{
                                                    cutout:65,
                                                    animation:false,
                                                    tooltips: {
                                                        enabled: false
                                                    },
                                                    events: [],
                                                    responsive: true,
                                                    maintainAspectRatio: true}} />
                                        </span>
                                        <span className="skill-img">
                                            <span className="skill-logo">{skill.icon}</span>
                                            <span className="skill-name">{skill.name}</span>
                                        </span>
                                    </div>)
                            })}
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default Skills;
